;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import clsx from 'clsx'
import React, { forwardRef } from 'react'

type TextareaProps = Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'size'> & {
  className?: string
  resizable?: boolean
  invalid?: boolean
}

export const Textarea = forwardRef(function Textarea(
  { className, resizable = true, invalid, disabled, ...props }: TextareaProps,
  ref: React.ForwardedRef<HTMLTextAreaElement>,
) {
  return (
    <span data-slot="control" className={clsx(className, 'relative block w-full')}>
      <textarea
        ref={ref}
        {...props}
        disabled={disabled}
        data-invalid={invalid || undefined}
        data-disabled={disabled || undefined}
        className={clsx([
          'relative block h-full w-full appearance-none rounded-xl px-4 py-3 text-sm/7',
          'text-mist-950 placeholder:text-mist-500 dark:text-white dark:placeholder:text-mist-400',
          'border border-mist-950/10 bg-white shadow-sm dark:border-white/10 dark:bg-mist-950/70',
          'focus:border-mist-950/40 focus:ring-4 focus:ring-mist-950/5 focus:outline-hidden dark:focus:border-white/30 dark:focus:ring-white/10',
          'data-[invalid=true]:border-red-500 data-[invalid=true]:hover:border-red-500 data-[invalid=true]:focus:border-red-500 data-[invalid=true]:focus:ring-red-500/20 dark:data-[invalid=true]:border-red-600 dark:data-[invalid=true]:hover:border-red-600 dark:data-[invalid=true]:focus:border-red-600 dark:data-[invalid=true]:focus:ring-red-500/25',
          'data-[disabled=true]:bg-mist-950/5 data-[disabled=true]:opacity-50 dark:data-[disabled=true]:bg-white/5',
          resizable ? 'resize-y' : 'resize-none',
        ])}
      />
    </span>
  )
})
